export const QUEUE_REQUESTNG = "REQUESTING";
export const QUEUE_PROCESSING = "PROCESSING";
export const QUEUE_SUCCESS = "SUCCESS";
export const QUEUE_ERROR = "ERROR";
